import React, { useState, useEffect } from "react";
import "./CustomCookieConsent.css";

const CustomCookieConsent = () => {
  const [showConsent, setShowConsent] = useState(false);
  const [settingsVisible, setSettingsVisible] = useState(false);
  const [analyticsEnabled, setAnalyticsEnabled] = useState(false);
  const [personalizationEnabled, setPersonalizationEnabled] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) setShowConsent(true);
  }, []);

  const savePreferences = () => {
    const preferences = {
      analytics: analyticsEnabled,
      personalization: personalizationEnabled,
    };
    localStorage.setItem("cookieConsent", JSON.stringify(preferences));
    setShowConsent(false);
  };

  const acceptAll = () => {
    localStorage.setItem("cookieConsent", JSON.stringify({
      analytics: true,
      personalization: true,
    }));
    setShowConsent(false);
  };

  const rejectAll = () => {
    localStorage.setItem("cookieConsent", JSON.stringify({
      analytics: false,
      personalization: false,
    }));
    setShowConsent(false);
  };

  if (!showConsent) return null;

  return (
    <div className="cookie-container" role="region" aria-labelledby="cookie-consent-title">
      <h2 id="cookie-consent-title">Uso de Cookies</h2> <br />
      <p> En <strong>Sparkling Tech Solutions</strong> utilizamos cookies para mejorar tu experiencia de navegación y optimizar nuestro sitio web. Algunas cookies son esenciales para el funcionamiento técnico, mientras que otras nos ayudan a entender cómo se utiliza el sitio o a personalizar tu experiencia. <br />
      <br />
      Puedes aceptar todas estas cookies pulsando el botón <strong>Aceptar Cookies</strong>, configurarlas o rechazar su uso pulsando <strong>Configurar Cookies</strong>.</p>
      
      <p style={{ fontSize: "13px", marginTop: "10px" }}>
        Si quieres más información, consulta la <a href="/uso-cookies" style={{ textDecoration: "underline", color: "rgb(63, 81, 181)" }}>
          política de cookies.
        </a>
      </p>
        

      {settingsVisible && (
        <>
          <div className="cookie-group">
            <div>
            <h4 id="cookie-technical-label">Cookies técnicas necesarias</h4>
            <p>Son necesarias para el funcionamiento del sitio web. Siempre están activadas.</p>
            </div>
            <input type="checkbox" checked disabled aria-labelledby="cookie-technical-label" />
          </div>

          <div className="cookie-group">
            <div>
              <h4 id="cookie-analytics-label">Cookies analíticas</h4>
              <p>Permiten analizar el tráfico y el rendimiento del sitio.</p>
            </div>
            <input
              type="checkbox"
              checked={analyticsEnabled}
              onChange={() => setAnalyticsEnabled(!analyticsEnabled)}
              aria-labelledby="cookie-analytics-label"
            />
          </div>
          <div className="cookie-group">
            <div>
              <h4 id="cookie-personalization-label">Cookies de personalización</h4>
              <p>Almacenan tus preferencias para mejorar la experiencia.</p>
            </div>
            <input
              type="checkbox"
              checked={personalizationEnabled}
              onChange={() => setPersonalizationEnabled(!personalizationEnabled)}
              aria-labelledby="cookie-personalization-label"
            />
          </div>
        </>
      )}

      <div className="cookie-buttons">
        {settingsVisible ? (
          <>
            <button onClick={savePreferences}>Aceptar selección</button>
            <button onClick={rejectAll}>Rechazar cookies</button>
          </>
        ) : (
          <>
            <button onClick={acceptAll}>Aceptar cookies</button>
            <button onClick={() => setSettingsVisible(true)}>Configurar cookies</button>
          </>
        )}
      </div>
      
    </div>
  );
};

export default CustomCookieConsent;
